import { action } from '../action';
import {
  GET_USER_PERMISSIONS_AND_ROLES_START,
  GET_USER_PERMISSIONS_AND_ROLES_SUCCESS,
  GET_USER_PERMISSIONS_AND_ROLES_FAIL,
  GET_USER_PERMISSIONS_START,
  GET_USER_PERMISSIONS_SUCCESS,
  GET_USER_PERMISSIONS_FAIL,
  SET_USER_PERMISSIONS_START,
  SET_USER_PERMISSIONS_SUCCESS,
  SET_USER_PERMISSIONS_FAIL,
  GET_CURRENT_USERS_PERMISSIONS_START,
  GET_CURRENT_USERS_PERMISSIONS_SUCCESS,
  GET_CURRENT_USERS_PERMISSIONS_FAIL
} from './constants';
import { requestGetRoles, requestSetRoles } from '../../api/role';
import { requestGetUserPermissions } from '../../api/user';

/*
Input Data:
{
  "permissions": [
    {
      "id": 22,
      "name": "",
      "slug": "create_bonus_cards",
      "section": {                            // or can be null! Then call section as undefined
        "id": 1,  // 1 - Bonuses, 2 - Users, ...
        "name": "Бонус сервис",
        "slug": "bonus"
      }
    },
  ],
  "roles": [
    {
      "name": "Администратор",
      "id": rolesID.ROLE_ADMINISTRATOR,
      "permissions": [22]
    }
  ]
}

Output Data:
{
  roles: [
    {
      id: rolesID.ROLE_ADMINISTRATOR,
      name: 'Администратор',
    }
  ],
  permissions: {
    bonus: {
      sectionId: 1,
      sectionName: 'Бонус сервис',
      items: [
        {
          id: 22,
          name: '',
          slug: 'create_bonus_card',
          "permissions": [rolesID.ROLE_ADMINISTRATOR]
        }
      ]
    }
  }
}
*/
const aggregateRolesAndPermissions = (rolesData) => {
  const inputRoles = rolesData.roles || [];
  const inputPermissions = rolesData.permissions || [];
  const aggregatePermissions = {};

  inputPermissions.forEach((permission) => {
    let {id, name, slug, section} = permission;

    if (!name) return;    // #330402 - temporary disable showing permissions with empty name (only by slug)
    if (!section) {
      section = { name: 'Не определена', slug: 'undefined' };
    }
    if (!aggregatePermissions[section.slug]) {
      const {id: sectionId, name: sectionName} = section;
      aggregatePermissions[section.slug] = {sectionId, sectionName};
    }
    if (!aggregatePermissions[section.slug].items) {
      aggregatePermissions[section.slug].items = [];
    }
    aggregatePermissions[section.slug].items.push({id, name, slug});
  });

  const collectedRoles = inputRoles.map((role) => ({id: role.id, name: role.name}));

  Object.keys(aggregatePermissions).forEach((sectionSlug) => {
    aggregatePermissions[sectionSlug].items.forEach((item) => {
      if (!item.permissions) {
        item.permissions = [];
      }

      inputRoles.forEach((role) => {
        const sectionItem = role.permissions.find((permissionId) => permissionId === item.id);

        if (sectionItem) {
          item.permissions.push(role.id);
        }
      });
    });
  });

  return { permissions: aggregatePermissions, roles: collectedRoles };
}

export const actionsGetUserRoles = action(
  GET_USER_PERMISSIONS_AND_ROLES_START,
  GET_USER_PERMISSIONS_AND_ROLES_SUCCESS,
  GET_USER_PERMISSIONS_AND_ROLES_FAIL
);
export const getUserRoles = () => async (dispatch) => {
  try {
    dispatch(actionsGetUserRoles.start());
    const data = await requestGetRoles();
    dispatch(actionsGetUserRoles.success(aggregateRolesAndPermissions(data)));
  } catch (error) {
    dispatch(actionsGetUserRoles.fail(error.detail));
  }
};

export const actionsSetUserPermissions = action(
  SET_USER_PERMISSIONS_START,
  SET_USER_PERMISSIONS_SUCCESS,
  SET_USER_PERMISSIONS_FAIL
);
export const setUserPermissions = (roleId, payload) => async (dispatch) => {
  try {
    dispatch(actionsSetUserPermissions.start());
    const data = await requestSetRoles(roleId, payload);
    dispatch(actionsSetUserPermissions.success({
      roleId,
      permissionId: payload.permission_id,
      status: data.status ? payload.status : !payload.status,
    }));
  } catch (error) {
    dispatch(actionsSetUserPermissions.fail(error.detail));
  }
};

export const actionsGetUserPermissions = action(
  GET_USER_PERMISSIONS_START,
  GET_USER_PERMISSIONS_SUCCESS,
  GET_USER_PERMISSIONS_FAIL,
);
export const getUserPermissions = () => async (dispatch) => {
  try {
    dispatch(actionsGetUserPermissions.start());
    const data = await requestGetUserPermissions();
    dispatch(actionsGetUserPermissions.success(data));
  } catch (error) {
    dispatch(actionsGetUserPermissions.fail(error.detail));
  }
};

export const actionsGetCurrentUsersPermissions = action(
  GET_CURRENT_USERS_PERMISSIONS_START,
  GET_CURRENT_USERS_PERMISSIONS_SUCCESS,
  GET_CURRENT_USERS_PERMISSIONS_FAIL,
);
export const getCurrentUsersPermissions = (payload) => async (dispatch) => {
  try {
    dispatch(actionsGetCurrentUsersPermissions.start());
    dispatch(actionsGetCurrentUsersPermissions.success(payload));
  } catch (error) {
    dispatch(actionsGetCurrentUsersPermissions.fail(error.detail));
  }
};
